import { Spacer as NbSpacer } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Spacer = NbSpacer;

export default addWithConfig(Spacer);
